export default __webpack_public_path__ + "832bd85fb872d48c845746c478efdb1b.jpg";